// @flow
import { get, put } from '../utils/api';

const base = (organizationId: string, propertyId: string) =>
  `/${organizationId}/${propertyId}/variance-report`;

class VarianceReportService {
  getVarianceReport(organizationId: string, propertyId: string, month: string) {
    const params = new URLSearchParams({ month });
    return get(`${base(organizationId, propertyId)}?${params.toString()}`);
  }

  getVarianceReportGlDetail(
    organizationId: string,
    propertyId: string,
    month: string,
    accountNo: string,
    range: 'month' | 'ytd',
  ) {
    const params = new URLSearchParams({ month, accountNo, range });
    return get(
      `${base(organizationId, propertyId)}/gl-detail?${params.toString()}`,
    );
  }

  updateVarianceReportNote(
    organizationId: string,
    propertyId: string,
    payload: { month: string, accountNo: string, note: string },
  ) {
    return put(
      `${base(organizationId, propertyId)}/notes`,
      JSON.stringify(payload),
    );
  }
}

export default VarianceReportService;
